module.exports = __webpack_public_path__ + "img/wheelExcavator-icon4.b282ac64.png";